module.exports = __webpack_public_path__ + "static/media/GREEN.3413c370.png";